import { Box, Button, Icon, IconButton, Stack, Tab, Tabs, Typography, useMediaQuery, useTheme } from '@mui/material';
import * as React from 'react';
import { Outlet, useNavigate, useParams } from 'react-router';
import { useProject } from '../Contexts/Hooks/useProject';
import { RycIsProjectModule } from '../Enums/RycIsProjectModule';
import { ArrowBack, AttachEmail, AttachMoney, EmojiEvents, Folder, Info, PeopleOutline, ViewInAr } from '@mui/icons-material';

export interface IProjectLayoutInnerProps {
}

export default function ProjectLayoutInner(props: IProjectLayoutInnerProps) {
    const projectLayout = useProject();
    const navigate = useNavigate();
    const theme = useTheme();
    const biggerThan500 = useMediaQuery(theme.breakpoints.up(500));
    const params = useParams<{ id: string }>();
    const handleTabChange = (event: React.SyntheticEvent, newValue: string) => {
        navigate(`/logged/projects/${params.id}/${newValue}`);
    };
    const getCurrentTabValue = () => {
        if (projectLayout.currentModule === RycIsProjectModule.Detail) return 'detail';
        if (projectLayout.currentModule === RycIsProjectModule.Budget) return 'budget';
        if (projectLayout.currentModule === RycIsProjectModule.Viewer) return 'viewer';
        if (projectLayout.currentModule === RycIsProjectModule.Files) return 'files';
        if (projectLayout.currentModule === RycIsProjectModule.Users) return 'users';
        if (projectLayout.currentModule === RycIsProjectModule.InternalOffer) return 'offer-admin';
        return false;
    };

    return (
        <Stack width={'100vw'} maxWidth={'100vw'} overflow='hidden' bgcolor='white' >
            {/* <Box zIndex={2} width={'100%'} display='flex' justifyContent='space-between' position='fixed'  bgcolor='primary.main' >
                
            </Box> */}
            <Box zIndex={2} width={'100%'} display='flex' py={1} px={4} justifyContent='space-between' position='fixed'>
                <Stack direction={'row'} spacing={1} alignItems={'center'}>
                    <IconButton onClick={() => navigate('/logged/projects')}><ArrowBack /></IconButton>
                    <Typography variant='h6'>{projectLayout.moduleName}</Typography>
                </Stack>
                {projectLayout.menuButtons}
            </Box>
            {projectLayout.currentModule !== RycIsProjectModule.None && (
                <Box mt={6} zIndex={4}>
                    <Tabs
                        value={getCurrentTabValue()}
                        onChange={handleTabChange}
                        textColor="primary"
                        indicatorColor="primary"
                        
                        sx={{ minHeight: '40px' }}
                    >
                        <Tab
                            value="detail"
                            icon={<Info />}
                            iconPosition="start"
                            label={biggerThan500 && "detail"}
                            sx={{
                                minHeight: '40px',
                                py: 0.5,
                                minWidth: biggerThan500 ? '90px' : '60px',
                                maxWidth: biggerThan500 ? '160px' : '60px'
                            }}
                        />
                        <Tab
                            value="offer-admin"
                            icon={<EmojiEvents />}
                            iconPosition="start"
                            label={biggerThan500 && "Nabídka"}
                            sx={{
                                minHeight: '40px',
                                py: 0.5,
                                minWidth: biggerThan500 ? '90px' : '60px',
                                maxWidth: biggerThan500 ? '160px' : '60px'
                            }}
                        />
                        <Tab
                            value="viewer"
                            icon={<ViewInAr />}
                            iconPosition="start"
                            label={biggerThan500 && "Model"}
                            sx={{
                                minHeight: '40px',
                                py: 0.5,
                                minWidth: biggerThan500 ? '90px' : '60px',
                                maxWidth: biggerThan500 ? '160px' : '60px'
                            }}
                        />
                        <Tab
                            value="budget"
                            icon={<AttachMoney />}
                            iconPosition="start"
                            label={biggerThan500 && "Rozpočet"}
                            sx={{
                                minHeight: '40px',
                                py: 0.5,
                                minWidth: biggerThan500 ? '90px' : '60px',
                                maxWidth: biggerThan500 ? '160px' : '60px'
                            }}
                        />
                        <Tab
                            value="files"
                            icon={<Folder />}
                            iconPosition="start"
                            label={biggerThan500 && "Soubory"}
                            sx={{
                                minHeight: '40px',
                                py: 0.5,
                                minWidth: biggerThan500 ? '90px' : '60px',
                                maxWidth: biggerThan500 ? '160px' : '60px'
                            }}
                        />
                        <Tab
                            value="users"
                            icon={<PeopleOutline />}
                            iconPosition="start"
                            label={biggerThan500 && "Uživatelé"}
                            sx={{
                                minHeight: '40px',
                                py: 0.5,
                                minWidth: biggerThan500 ? '90px' : '60px',
                                maxWidth: biggerThan500 ? '160px' : '60px'
                            }}
                        />

                    </Tabs>
                </Box>
            )}

            <Box overflow='hidden' >
                <Outlet />
            </Box>
        </Stack >
    );
}
